import { render, staticRenderFns } from "./TableScore.vue?vue&type=template&id=30bcbeea&scoped=true"
import script from "./TableScore.vue?vue&type=script&lang=js"
export * from "./TableScore.vue?vue&type=script&lang=js"
import style0 from "./TableScore.vue?vue&type=style&index=0&id=30bcbeea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bcbeea",
  null
  
)

export default component.exports